// Army colours for the watching readouts, echoing the pieces on the board.
//
// **A colour is the client's** (PLAN-CLIENT-SPLIT day 6's ruling for the
// stance colours and `RARITY_COLOUR`): the engine names an army, this paints
// it. A short cycle rather than a lookup into the renderer — `PALETTE` names
// the two classic sides and nothing else, and a run cycles through up to eight,
// so a wave under a flag the palette has never heard of still needs a swatch.

import type { Side } from "src/api";

const ARMY_TONE = [
  "#f4edd9",
  "#a8c3ce",
  "#d1b566",
  "#98bdcb",
  "#e8b09a",
  "#afcbd6",
  "#e8a88f",
  "#e8a077"
];

/** The swatch for one army, wrapping past the eighth. */
export const armyTone = (side: Side): string => ARMY_TONE[side % ARMY_TONE.length];
